<template>
	<div>
		<Hrader :flexKey="1" @clickEmit="emitInfo"></Hrader>
		<div style="height: 70px"></div>
		<div class="flex-asstes">
			<div class="tabar-card">
				<div class="title-row">您当前搜索的关键词为“{{title}}”，为您找到以下相关结果：</div>

				<div class="row-flex">
					<div class="colcting-rectang" v-for="(item, index) in listData" :key="index" @click="routeClick(item)">
						<img :src="item.coverImg" style="height: 49px" />
						<div class="title-frame">{{item.name}}</div>
					</div>
					<div style="margin: auto; margin-top: 30px;">
						 <el-empty v-if="listData.length==0" description="暂无数据" />
					</div>
				</div>
			</div>
		</div>
		<Tabr></Tabr>
	</div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import Hrader from '@/components/header.vue';
import Tabr from '@/components/tabrButton.vue';
import { useRoute,useRouter } from 'vue-router';
import { cardListPost } from '@/utils/api.js';
let information = ref({});
let listData = ref([]);
let route = useRoute();
let router = useRouter();
let title = ref('');

onMounted(() => {
	let infomation = localStorage.getItem('information');
	information.value = JSON.parse(infomation);
	info();
});

const info = () => {
	if(!route.query.key){
		return false;
	}
	cardListPost({
		categoryId:null,
		searchKey: route.query.key,
	}).then(res=>{
		title.value = route.query.key;
		listData.value = res.data;
	})
};

const emitInfo = (item) =>{
	if(!item){
		return false;
	}
	cardListPost({
		categoryId:null,
		searchKey: item,
	}).then(res=>{
		title.value = item;
		listData.value = res.data;
	})
}

const routeClick = (item) => {
	if (!information.value) {
		router.push({
			path: '/login'
		});
		return false;
	}
	router.push({
		path: '/cardVoucher',
		query: {
			ids: item.id,
			categoryId: item.categoryId
		}
	});
};
</script>

<style scoped lang="scss">
.tabar-card {
	height: 556px;
}
.flex-asstes {
	width: 1280px;
	margin: auto;
}
.title-row {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 18px;
	font-style: normal;
	text-transform: none;
	margin-top: 50px;
}
.phone-charge {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 20px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-top: 20px;
}

.row-flex {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	margin-left: -20px;
}

.colcting-rectang {
	padding: 10px 50px;
	background: #ffffff;
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
	border-radius: 4px 4px 4px 4px;
	border: 1px solid #eeeeee;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	margin-top: 30px;
	margin-left: 20px;
}

.colcting-rectang:hover {
	cursor: pointer;
	border: 1px solid #ff2e27;
}

.title-frame {
	font-family: PingFang SC, PingFang SC;
	font-weight: 500;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	margin-top: 5px;
	text-transform: none;
}
</style>
